// extracted by mini-css-extract-plugin
export var banner = "_fy-0";
export var closeButton = "_fy-2";
export var greenCheckmark = "_fy-3";
export var hereLink = "_fy-4";
export var titleIcon = "_fy-1";